import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader } from '../../components/ui/card';
import { Sparkles } from 'lucide-react';
import CoachingNugget from '../../components/CoachingNugget';
import SocialVoiceForm from '../../components/social/SocialVoiceForm';

/**
 * SocialVoiceScreen
 * Onboarding step inserted between Branding Setup and Completion.
 * Renders SocialVoiceForm and handles the "Save and continue" → /onboarding/completion
 * navigation via the form's onSaved callback. Also offers a "Skip for now" link
 * that bypasses the save and jumps straight to completion (mirrors the skip-link
 * pattern from BrandingSetupScreen).
 */
const SocialVoiceScreen = () => {
  const navigate = useNavigate();

  const goToCompletion = () => navigate('/onboarding/completion');

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-white flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-4 pb-6">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/10">
              <Sparkles className="w-6 h-6 text-primary" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900">Your Social Voice</h1>
          </div>
          <p className="text-gray-600 text-sm">
            Four quick questions so the Social Post tool sounds like you. You can change any of
            this later in your Branding Profile.
          </p>
        </CardHeader>

        <CardContent className="space-y-6">
          {/* hideHeader=false so the form's own subtitle ("Used to personalize Social Post.")
              shows beneath the screen header. The form's Save button label is "Save" — the
              onSaved callback advances the user to /onboarding/completion. */}
          <SocialVoiceForm hideHeader={false} onSaved={goToCompletion} />

          <CoachingNugget>
            Tell the AI how you sound now and every post will read like you wrote it — no more
            generic real estate copy.
          </CoachingNugget>

          <button
            type="button"
            onClick={goToCompletion}
            className="w-full text-sm text-gray-400 hover:text-gray-600 transition-colors"
            data-testid="social-voice-skip-btn"
          >
            Skip for now — I'll set this up later
          </button>
        </CardContent>
      </Card>
    </div>
  );
};

export default SocialVoiceScreen;
